<div class="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
  <div class="max-w-md w-full space-y-8">
    <div>
      <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900">
        Admin Login
      </h2>
      <p class="mt-2 text-center text-sm text-gray-600">
        SKO Süd Verwaltung
      </p>
    </div>

    <form class="mt-8 space-y-6" (ngSubmit)="onSubmit()">
      <div class="rounded-md shadow-sm -space-y-px">
        <div>
          <label for="username" class="sr-only">Benutzername</label>
          <input
            id="username"
            name="username"
            type="text"
            required
            [(ngModel)]="username"
            class="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
            placeholder="Benutzername"
            [disabled]="isLoading()"
          />
        </div>
        <div>
          <label for="password" class="sr-only">Passwort</label>
          <input
            id="password"
            name="password"
            type="password"
            required
            [(ngModel)]="password"
            class="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
            placeholder="Passwort"
            [disabled]="isLoading()"
          />
        </div>
      </div>

      @if (errorMessage()) {
        <div class="rounded-md bg-red-50 p-4">
          <div class="flex">
            <div class="ml-3">
              <h3 class="text-sm font-medium text-red-800">
                {{ errorMessage() }}
              </h3>
            </div>
          </div>
        </div>
      }

      <div>
        <button
          type="submit"
          [disabled]="isLoading()"
          class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          @if (isLoading()) {
            <span>Wird geladen...</span>
          } @else {
            <span>Anmelden</span>
          }
        </button>
      </div>

      <div class="text-center">
        <a routerLink="/" class="text-sm text-blue-600 hover:text-blue-500">
          Zurück zur Startseite
        </a>
      </div>
    </form>
  </div>
</div>
